import { useTranslation } from "react-i18next";
import "./AssetBrowser.css";
import Grid from "../../components/grid/Grid";
import { useState, useEffect } from "react";
import { getAssetsForBrowser } from "../../services/AssetBrowserAPI";
import AssetFilter from "../../components/filters/assetFilter/AssetFilter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleXmark,
  faMicrophoneSlash
} from "@fortawesome/free-solid-svg-icons";

const AssetBrowser = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const headers = [
    { key: "id", label: "ID", visible: false },
    { key: "connectionStatus", visible: false },
    {
      key: "isOnline",
      label: "Status",
      width: "10%",
      alignHeader: "center",
      alignContent: "center",
    },
    { key: "modelNumber", label: "Model", width: "15%" },
    { key: "serialNumber", label: "Serial Number", width: "20%" },
    { key: "location", label: "Location", width: "40%" },
    { key: "swVersion", label: "SW Version", width: "15%" },
  ];

  const mapApiResponseToGridData = (dataArray) => {
    return dataArray.map((item, index) => {
      const isMuted = item.muted === "yes"; // adjust if boolean

      return {
        id: index + 1,
        connectionStatus: item.connection_status,

        isOnline: isMuted ? (
          <FontAwesomeIcon
            icon={faMicrophoneSlash}
            aria-label="muted"
            title="Muted"
          />
        ) : item.connection_status === "connected" ? (
          <FontAwesomeIcon
            icon={faCircleCheck}
            style={{ color: "green" }}
            aria-label="connected"
            title="Connected"
          />
        ) : (
          <FontAwesomeIcon
            icon={faCircleXmark}
            style={{ color: "red" }}
            aria-label="disconnected"
            title="Disconnected"
          />
        ),

        modelNumber: item.parameters?.DeviceModel ?? item.analyzer_model ?? "",
        serialNumber:
          item.parameters?.DeviceSerial ?? item.system_serial_number ?? "",
        location: item.di_location,
        swVersion: item.di_sw_version,
      };
    });
  };


  const loadData = async (searchData) => {
    try {
      setLoading(true);
      const raw = await getAssetsForBrowser(searchData); // Fetch real data from signed AWS request
      const formatted = Array.isArray(raw) ? raw : [raw]; // Ensure it's an array
      const mapped = mapApiResponseToGridData(formatted);
      setData(mapped);
    } catch (err) {
      console.error("Fetch failed:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleRowDoubleClick = (rowData) => {
    const model = rowData.modelNumber;
    const serialNumber = rowData.serialNumber;

    const url = `/asset-dashboard?model=${model}&serialNumber=${serialNumber}`;

    window.open(url, "_blank");
  };

  return (
    <div className="home-page-wrapper">
      <div className="home-header">
        <h4>{t("Asset Browser")}</h4>
      </div>
      <div>
        <AssetFilter onSearch={loadData} onReset={loadData} />
      </div>
      <div className="home-content">
        <Grid
          headers={headers}
          data={data}
          rowsPerPage={100}
          canMultiSelect={false}
          onRowClick={handleRowDoubleClick}
          loading={loading}
          sortable={true}
        />
      </div>
    </div>
  );
};

export default AssetBrowser;
